<template>
    <div>
        <div class="field-card">

            <div class="growth-summary" v-if="cropperiod_data">

                <b-row align-v="center">
                    <b-col md=4>
                        <div>
                            <div class="sub-title">栽種時間</div>
                            <div class="growth-summary-block">
                                {{ this.$moment( cropperiod_data.start_date ).format('YYYY-MM-DD') }}
                                <span v-if="cropperiod_data.end_date">
                                    <i class="fa fa-minus"></i>
                                    {{ this.$moment( cropperiod_data.end_date ).format('YYYY-MM-DD') }}
                                </span>
                                ( {{ count_Dates( cropperiod_data ) }} )
                            </div>
                        </div>
                    </b-col>

                    <b-col md=4>
                        <div>
                            <div class="sub-title">生長階段</div>
                            <div class="growth-summary-block">
                                <div class="growth-summary-stage">{{ cropperiod_data.stage.current_growth_stage }}</div>
                            </div>
                            <!-- <div class="growth-summary-block">
                                <div class="growth-summary-info">{{ cropperiod_data.current_growth_stage_description }}</div>
                            </div> -->
                        </div>
                    </b-col>

                    <b-col md=4>
                        <div class="progress-block">
                            <div class="sub-title">生長進度</div>
                            <div class="progress-block-bar">
                                <b-progress :max="100" height="25px" variant="success" striped :animated="true">
                                    <b-progress-bar :value="parseInt( cropperiod_data.stage.whole_percentage )">
                                        <span>
                                            <strong>{{ parseInt( cropperiod_data.stage.whole_percentage ) }} %</strong>
                                        </span>
                                    </b-progress-bar>
                                </b-progress>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                
            </div>



            <div>
                <b-row>
                    <b-col lg=6 class="growth-tasks">
                        <div class="sub-title">
                            田間管理
                            <!-- <i class="fas fa-sort-down"></i> -->
                        </div>
                        
                        <div v-if="loading_tasks">
                            <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
                        </div>

                        <span v-if="field_tasks.length == 0">無任務</span>
                        <div v-else>
                            <div v-for="(item, idx) in field_tasks" :key="idx"
                                class="task-block"
                                :style="get_TaskStyle(item)"
                                @click="show_Modal(item)">
                                <div class="task-block-name">
                                    {{ get_limitedString( item.name, 4 ) }}
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col lg=6 class="growth-tasks">
                        <div class="sub-title">
                            注意病蟲害
                            <!-- <i class="fas fa-sort-down"></i> -->
                        </div>

                        <div v-if="loading_growth">
                            <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
                        </div>

                        <span v-if="field_pest_disease.length == 0">無</span>
                        <div v-else>
                            <div v-for="(item, idx) in field_pest_disease" :key="idx"
                                class="task-block"
                                :style="get_TaskStyle(item)"
                                @click="show_Modal(item)">
                                <div class="task-block-name">
                                    {{ get_limitedString( item.name, 4 ) }}
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>

        </div>



        <b-modal v-if="modal_data"
                v-model="show_modal"
                :title="modal_data.name"
                header-bg-variant="success"
                hide-header-close hide-footer>
            
            <div class="modal-body scroll-style">

                <div v-if="modal_data.description_lines && modal_data.description_lines.length > 0">
                    <p v-for="(line, idx) in modal_data.description_lines" :key="idx">
                        {{ line }}
                    </p>
                </div>
                <p v-else-if="modal_data.description">
                    {{ modal_data.description }}
                </p>
                <p v-else>( 無描述 )</p>

                <p v-if="modal_data.pic">
                    <b-img thumbnail fluid :src="$config.checkURL('photo', modal_data.pic)" :alt="modal_data.name + '參考圖片'"></b-img>
                </p>
                <p v-else class="modal-no-pic">
                    無參考圖片
                </p>
                <div class="modal-license">
                    <div v-html="modal_data.license"></div>
                </div>
            
            </div>
            <div class="text-center">
                <b-button variant="secondary" size="lg" @click="show_modal = false">關閉</b-button>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import AgriLoading from '@/views/components/AgriLoading'

export default {
    props: {
        cropperiod: {
            type: Object,
            required: true,
        },
    },
    components: {
        AgriLoading,
    },
    data () {
        return {
            show_modal: false,
            modal_data: undefined,

            loading_tasks: false,
            loading_growth: false,

            field_tasks: [],
            field_pest_disease: [],
        }
    },
    mounted ()
    {
        this.change_Field_Data()
    },
    computed: {
        ...mapState({
            // 'cropperiod_detail': state => state.cropperiod.cropperiod,
        }),

        cropperiod_data ()
        {
            // return {
            //     start_date: '2020-07-24 16:00:00',
            //     stage: {
            //         current_growth_stage: '成熟期',
            //         whole_percentage: 80,
            //     },
            // }
            return this.cropperiod
        },
    },
    watch: {

    },
    methods: {

        show_Modal (item)
        {
            this.modal_data = item
            this.show_modal = true
        },

        get_TaskStyle (item)
        {
            // console.log( item.pic )
            return {
                backgroundImage: `url(${ item.pic })`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
            }
        },

        get_limitedString (text, max_length = 5)
        {
            if (text && text.length > max_length)
            {
                return text.slice(0,max_length) + '...'
            }
            return text
        },

        filter_Params (param)
        {
            switch (param)
            {
                case 'air_temperature': return true
                case 'air_humidity':    return true
                case 'rainfalls':       return true
                case 'solar_radiation': return true
                default: return false
            }
        },

        count_Dates (field_info)
        {
            let _unit = ( field_info.end_date != undefined ? ' 天' : ' 天前' )
            let _count = this.$tools.date.countDays( field_info.start_date, field_info.end_date )
            return Math.abs( _count ) + _unit
        },


        // API 取資料
        change_Field_Data ()
        {
            this.get_Field_Tasks()
            this.get_Field_Growth()
        },


        // 取得生長期相關資訊：田間任務
        get_Field_Tasks ()
        {
            this.loading_tasks = true
            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('Get_GrowthStage_Tasks', { cropperiodID: this.cropperiod.id }),
            }
            this.$http(options)
            .then( res => {
                // console.log( res.data )

                if ( res.data.stage_tasks )
                {
                    this.field_tasks = res.data.stage_tasks
                }
                else this.field_tasks = []

                this.loading_tasks = false
            })
            .catch( err => {
                this.loading_tasks = false
            })
            
            // this.field_tasks = [
            //     {
            //         "name": "灌水",
            //         "description": "由於水稻齊穗後植株最上部三片葉子為主要進行光合作用生產碳水化合物的工廠，需仰賴充足的水分輸送轉存至穀粒，故仍應採用5至10公分的深水灌溉。",
            //         "pic": "https://storage.googleapis.com/turtwig-cloud-storage/stages/work/0001_ripening_cereals_W002_0.jpeg",
            //         "license": "<p style=\"font-size: 0.9rem;font-style: italic;\"><a href=\"https://www.flickr.com/photos/28585409@N04/3710697797\">\"Irrigation ditches and sprinkler\"</a><span> by <a href=\"https://www.flickr.com/photos/28585409@N04\">Sam Beebe</a></span> is licensed under <a href=\"https://creativecommons.org/licenses/by/2.0/?ref=ccsearch&atype=html\" style=\"margin-right: 5px;\">CC BY 2.0</a><a href=\"https://creativecommons.org/licenses/by/2.0/?ref=ccsearch&atype=html\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"display: inline-block;white-space: none;margin-top: 2px;margin-left: 3px;height: 22px !important;\"><img style=\"height: inherit;margin-right: 3px;display: inline-block;\" src=\"https://search.creativecommons.org/static/img/cc_icon.svg?image_id=680eb9e5-7ce6-4dac-9070-f71219740b24\" /><img style=\"height: inherit;margin-right: 3px;display: inline-block;\" src=\"https://search.creativecommons.org/static/img/cc-by_icon.svg\" /></a></p>"
            //     },
            //     {
            //         "name": "斷水曬田",
            //         "description": "水稻抽穗後約18天開始進入黃熟期，此時上部葉仍繼續進行光合作用合成碳水化合物，所以仍不宜太早斷水，應採用3至5天約3公分水深之輪灌2至3次，直至收穫前5至7天排水，以防穀粒充實不飽滿。",
            //         "pic": "https://storage.googleapis.com/turtwig-cloud-storage/stages/work/0001_ripening_cereals_W005_0.jpeg",
            //         "license": "<p style=\"font-size: 0.9rem;font-style: italic;\"><a href=\"https://www.flickr.com/photos/19935963@N00/34146145092\">\"Dry Fields\"</a><span> by <a href=\"https://www.flickr.com/photos/19935963@N00\">timo_w2s</a></span> is licensed under <a href=\"https://creativecommons.org/licenses/by-sa/2.0/?ref=ccsearch&atype=html\" style=\"margin-right: 5px;\">CC BY-SA 2.0</a><a href=\"https://creativecommons.org/licenses/by-sa/2.0/?ref=ccsearch&atype=html\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"display: inline-block;white-space: none;margin-top: 2px;margin-left: 3px;height: 22px !important;\"><img style=\"height: inherit;margin-right: 3px;display: inline-block;\" src=\"https://search.creativecommons.org/static/img/cc_icon.svg?image_id=cab7d141-6915-4c4e-8a36-13246796be0d\" /><img style=\"height: inherit;margin-right: 3px;display: inline-block;\" src=\"https://search.creativecommons.org/static/img/cc-by_icon.svg\" /><img style=\"height: inherit;margin-right: 3px;display: inline-block;\" src=\"https://search.creativecommons.org/static/img/cc-sa_icon.svg\" /></a></p>"
            //     }
            // ]
        },

        // 取得生長期相關資訊：生長階段、田間任務、病蟲害資訊
        get_Field_Growth ()
        {
            this.loading_growth = true
            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('Get_GrowthStage_PestDiseases', { cropperiodID: this.cropperiod.id }),
            }
            this.$http(options)
            .then( res => {
                // console.log( res.data )


                // 由於後端要合併 table 並跑回圈會非常麻煩，顧由前端將病蟲害對應代碼與對應行為連接在一起
                let _treatments_mapping = {}
                let _symptom_treatments = res.data.symptom_treatments
                // let _symptom_treatments = [
                //     {
                //         "crop_code": "0001",
                //         "pest_disease_code": "P0004",
                //         "pic": "https://storage.googleapis.com/turtwig-cloud-storage/stages/pestdisease/0001_P0004_0.jpeg",
                //         "license": "<p style=\"font-size: 0.9rem;font-style: italic;\"><a href=\"https://commons.wikimedia.org/w/index.php?curid=35380642\">\"File:Nilaparvata lugens - Brown planthopper - UGA5190055.jpg\"</a><span> by <a href=\"http://www.forestryimages.org/browse/detail.cfm?imgnum=5190055#sthash.UX6OgMTv.dpuf\">Natasha Wright, Florida Department of Agriculture and Consumer Services, Bugwood.org - See more at: http://www.forestryimages.org/browse/detail.cfm?imgnum=5190055#sthash.UX6OgMTv.dpuf</a></span> is licensed under <a href=\"https://creativecommons.org/licenses/by/3.0?ref=ccsearch&atype=html\" style=\"margin-right: 5px;\">CC BY 3.0</a><a href=\"https://creativecommons.org/licenses/by/3.0?ref=ccsearch&atype=html\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"display: inline-block;white-space: none;margin-top: 2px;margin-left: 3px;height: 22px !important;\"><img style=\"height: inherit;margin-right: 3px;display: inline-block;\" src=\"https://search.creativecommons.org/static/img/cc_icon.svg?image_id=70aac07d-33d3-4260-b20e-bb3163c87bfa\" /><img style=\"height: inherit;margin-right: 3px;display: inline-block;\" src=\"https://search.creativecommons.org/static/img/cc-by_icon.svg\" /></a></p>\r\n"
                //     },
                //     {
                //         "crop_code": "0001",
                //         "pest_disease_code": "P0003",
                //         "pic": "https://storage.googleapis.com/turtwig-cloud-storage/stages/pestdisease/0001_P0003_0.jpeg",
                //         "license": "<p style=\"font-size: 0.9rem;font-style: italic;\"><a href=\"https://www.flickr.com/photos/37180297@N08/40968316905\">\"_ESI6929 Chilo suppressalis\"</a><span> by <a href=\"https://www.flickr.com/photos/37180297@N08\">papilioshih</a></span> is licensed under <a href=\"https://creativecommons.org/licenses/by/2.0/?ref=ccsearch&atype=html\" style=\"margin-right: 5px;\">CC BY 2.0</a><a href=\"https://creativecommons.org/licenses/by/2.0/?ref=ccsearch&atype=html\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"display: inline-block;white-space: none;margin-top: 2px;margin-left: 3px;height: 22px !important;\"><img style=\"height: inherit;margin-right: 3px;display: inline-block;\" src=\"https://search.creativecommons.org/static/img/cc_icon.svg?image_id=0597bdd8-350b-402c-9c6d-ba7a147d2e54\" /><img style=\"height: inherit;margin-right: 3px;display: inline-block;\" src=\"https://search.creativecommons.org/static/img/cc-by_icon.svg\" /></a></p>"
                //     }
                // ]

                _symptom_treatments.forEach( _treat => {
                    _treatments_mapping[ _treat.pest_disease_code ] = _treat
                })

                let _pest_diseases = res.data.pest_diseases
                // let _pest_diseases =[
                //     {
                //         "pest_disease_code": "P0003",
                //         "name": "二化螟",
                //         "description": "病徵：葉鞘黃化；折葉、倒葉、流葉；捲心、枯心；白穗；莖桿側邊有蟲孔，內有蟲糞、蟲體\n耕作防治：控制氮肥量；收割稻盡量靠近地基部，將稻稿截短曝曬；移除殘株；提早翻犁；燃燒、氰化鈣降解、淹水等方法破壞稻稈及稻樁\n生物防治：白殭菌、黑殭菌、綠殭菌"
                //     },
                //     {
                //         "pest_disease_code": "P0004",
                //         "name": "褐飛蝨",
                //         "description": "病徵：密度低時，稻株黃化、稔實率下降；密度高時， 短期內迅速枯萎倒伏(常呈現圓圈狀分布，稱為蝨燒)\n防治：控制氮肥量；避免密植"
                //     }
                // ]
                _pest_diseases.forEach( _item => {
                    _item['description_lines'] = _item['description'].split('\n')  // 依 \n 切斷落
                    // _item['description'] = _item['description'].replace(/\n/g, '<br>')  // 將 \n 轉換為 <br>
                    _item['pic'] = _treatments_mapping[ _item.pest_disease_code ]['pic']
                    _item['license'] = _treatments_mapping[ _item.pest_disease_code ]['license']
                })

                this.field_pest_disease = _pest_diseases

                this.loading_growth = false
            })
            .catch( err => {
                this.loading_growth = false
            })
            
            
        },

    }
}
</script>

<style lang="scss" scoped>

.field-card
{
    
    .title
    {
        margin-top: 0px;
        margin-bottom: 0px;
    }
    .sub-title
    {
        display: inline-block;
        padding: 3px 10px;
        background-color: rgba( #9bb817, 0.3 );
        border-radius: 2px;
        margin-right: 10px;
    }
    .field-name
    {
        display: inline-block;
        margin-right: 20px;
    }
    .crop-name
    {
        display: inline-block;
        color: #637d38;
    }
    .fa-minus
    {
        margin: 0px 5px;
    }
}

.growth-summary
{
    .sub-title
    {
        margin-right: 0px;
    }

    .progress-block
    {
        font-size: 1.0rem;
        margin-bottom: 12px;

        .progress-block-bar
        {
            display: inline-block;
            vertical-align: middle;
            width: 55%;
            max-width: 300px;
            margin-left: 15px;
        }
        .progress-block-bar .progress
        {
            margin-bottom: 3px;
        }
        .progress-block-bar span strong
        {
            font-size: 1.1rem;
        }
    }

    .growth-summary-block
    {
        display: inline-block;
        margin-left: 15px;
        margin-bottom: 15px;
    }
    .growth-summary-stage
    {
        display: inline-block;
        font-size: 1.2rem;
        font-weight: 600;
    }
    .growth-summary-info
    {
        display: inline-block;
    }
}

.growth-tasks
{
    margin-bottom: 25px;

    .fa-sort-down {
        vertical-align: top;
        font-size: 1.4rem;
        line-height: 1rem;
    }

    .task-block
    {
        display: inline-block;
        width: 45%;
        min-height: 50px;
        text-align: center;
        vertical-align: top;
        background-color: rgba(179, 179, 179, 0.5);
        border-radius: 5px;
        margin: 10px 10px 0px 0px;

        .task-block-name
        {
            display: inline-block;
            margin: 15% 5%;
            padding: 0px 5px;
            border-radius: 2px;
            color: white;
            background-color: rgba(0, 0, 0, 0.3);
        }

        &:hover {
            cursor: pointer;
            transform: scale(1.08);
            
            border-radius: 5px;
            // border: 1px solid rgba(155, 184, 23, 0.5);
        }
    }
}


.modal
{
    width: 90vw !important;
}
.modal-body
{
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 1.2rem;
}
.modal-no-pic
{
    width: 100%;
    font-size: 0.9rem;
    text-align: center;
    padding: 40px;
    color: grey;
    background-color: #f2f2f2;
    border-radius: 3px;
}
.modal-license
{
    font-size: 0.9rem !important;
    font-style: italic;
}
.close-button
{
    padding: 8px 20px;
    font-size: 1.2rem;
}

</style>

<style lang="scss">



</style>